export default "__VITE_ASSET__vouI9JBu__"